// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileXlsOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 20a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm.672-12L14 4.328V8zm-4-6a2 2 0 0 1 1.414.586l4.328 4.328A2 2 0 0 1 20 8.328V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm3.17 9.93-.41.803c-.23-.184-.44-.268-.677-.268-.252 0-.441.147-.441.342 0 .073.037.152.094.2.116.094.158.11.62.246.688.205.972.526.972 1.114 0 .446-.137.793-.405 1.024-.283.242-.688.373-1.145.373-.467 0-.95-.152-1.37-.446l.44-.83c.321.278.605.404.91.404.299 0 .498-.152.498-.383 0-.216-.136-.316-.62-.457-.44-.132-.609-.205-.75-.32-.21-.174-.316-.437-.316-.789 0-.793.547-1.334 1.345-1.334.415 0 .856.116 1.255.32zm-8.292-.226.588 1.03.61-1.03h1.265l-1.287 1.849 1.492 2.111H9.973l-.84-1.287-.893 1.287H7l1.55-2.111-1.272-1.85zm5.24 3.088v.872h-2.263v-3.96h1.029v3.088z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileXlsOutline;
